import { Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { PageTransition } from '@/components/routing';

// Lazy load public pages
const Index = lazy(() => import('@/pages/Index'));
const About = lazy(() => import('@/pages/About'));
const Contact = lazy(() => import('@/pages/Contact'));
const Conseil = lazy(() => import('@/pages/Conseil'));
const Formations = lazy(() => import('@/pages/Formations'));
const FormationDetail = lazy(() => import('@/pages/FormationDetail'));
const CasClients = lazy(() => import('@/pages/CasClients'));
const CasClientDetail = lazy(() => import('@/pages/CasClientDetail'));
const Quote = lazy(() => import('@/pages/Quote'));
const FinancementOpco = lazy(() => import('@/pages/FinancementOpco'));
const PackAirtable = lazy(() => import('@/pages/PackAirtable'));
const CertificationsOutils = lazy(() => import('@/pages/CertificationsOutils'));
const Tarifs = lazy(() => import('@/pages/Tarifs'));
const Blog = lazy(() => import('@/pages/Blog'));
const BlogPost = lazy(() => import('@/pages/BlogPost'));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    Chargement...
  </div>
);

export function PublicRoutes() {
  return (
    <>
      <Route 
        path="/" 
        element={
          <Suspense fallback={<PageLoader />}>
            <PageTransition><Index /></PageTransition>
          </Suspense>
        } 
      />
      <Route 
        path="/about" 
        element={
          <Suspense fallback={<PageLoader />}>
            <PageTransition><About /></PageTransition>
          </Suspense>
        } 
      />
      <Route 
        path="/contact" 
        element={
          <Suspense fallback={<PageLoader />}>
            <PageTransition><Contact /></PageTransition>
          </Suspense>
        } 
      />
      <Route 
        path="/conseil" 
        element={
          <Suspense fallback={<PageLoader />}>
            <PageTransition><Conseil /></PageTransition>
          </Suspense>
        } 
      />
      <Route 
        path="/formations" 
        element={
          <Suspense fallback={<PageLoader />}>
            <PageTransition><Formations /></PageTransition>
          </Suspense>
        } 
      />
      <Route 
        path="/formation/:id" 
        element={
          <Suspense fallback={<PageLoader />}>
            <PageTransition><FormationDetail /></PageTransition>
          </Suspense>
        } 
      />
      <Route 
        path="/formations/packs/:slug" 
        element={
          <Suspense fallback={<PageLoader />}>
            <PageTransition><PackAirtable /></PageTransition>
          </Suspense>
        } 
      />
      <Route 
        path="/cas-clients" 
        element={
          <Suspense fallback={<PageLoader />}>
            <PageTransition><CasClients /></PageTransition>
          </Suspense>
        } 
      />
      <Route 
        path="/cas-clients/:id" 
        element={
          <Suspense fallback={<PageLoader />}>
            <PageTransition><CasClientDetail /></PageTransition>
          </Suspense>
        } 
      />
      <Route 
        path="/devis/:id"
        element={
          <Suspense fallback={<PageLoader />}>
            <PageTransition><Quote /></PageTransition>
          </Suspense>
        } 
      />
      <Route 
        path="/financement-opco" 
        element={
          <Suspense fallback={<PageLoader />}>
            <PageTransition><FinancementOpco /></PageTransition>
          </Suspense>
        } 
      />
      <Route 
        path="/certifications-outils" 
        element={
          <Suspense fallback={<PageLoader />}>
            <PageTransition><CertificationsOutils /></PageTransition>
          </Suspense>
        } 
      />
      <Route 
        path="/tarifs" 
        element={
          <Suspense fallback={<PageLoader />}>
            <PageTransition><Tarifs /></PageTransition>
          </Suspense>
        } 
      />
      <Route 
        path="/blog" 
        element={
          <Suspense fallback={<PageLoader />}>
            <PageTransition><Blog /></PageTransition>
          </Suspense>
        } 
      />
      <Route 
        path="/blog/:slug" 
        element={
          <Suspense fallback={<PageLoader />}>
            <PageTransition><BlogPost /></PageTransition>
          </Suspense>
        } 
      />
    </>
  );
}
